import * as server_js from './server.js'

export default [server_js]
